<app-card-view-layout (onAdd)="addNewVM()"  *ngIf="vmMachineArr" [data]="$machineArr"   [actionButtons]="actionButtons" (onDelete)="onDeleteMachine($event)"
(onUpdate)="onUpdateMachine($event)" [showAdd]="auth.isSuperAdmin(user)"  [showEdit]="true" [title]="" >

</app-card-view-layout>

<app-card-view-layout  [showEdit]="true" (onAdd)="addCal()" *ngIf="openLending" [data]="$openLendingArr"  [showAdd]="false" [title]="'Open modules:'">

</app-card-view-layout>


<app-card-view-layout  [showEdit]="true"  [data]="$pickupPointArr" *ngIf="pickuppoint" [showAdd]="false" [title]="">


</app-card-view-layout>